/* eslint-disable no-unused-vars */
import React from "react";
import { formatInteger } from "../../../../app/utils/formatNumber";

export function PaginationToolbar(props) {
  const { isLoading, paginationProps } = props;
  const {
    sizePerPageList = [],
    sizePerPage,
    totalSize,
    page = 1,
    onSizePerPageChange
  } = paginationProps;

  const pageSizeOptions = sizePerPageList
    .map((option) => {
      const pageSize = Number(option.page || option.value || option.text);
      return {
        page: pageSize,
        text: option.text || String(pageSize)
      };
    })
    .filter((option) => Number.isFinite(option.page));
  const currentSizePerPage = Number(sizePerPage);
  const fromRow = totalSize === 0 ? 0 : ((page - 1) * sizePerPage) + 1;
  const toRow = Math.min(page * sizePerPage, totalSize);
  const showPageSizeControls = (
    totalSize > currentSizePerPage &&
    pageSizeOptions.length > 1 &&
    typeof onSizePerPageChange === "function"
  );

  const changePageSize = (newSize) => {
    if (newSize !== currentSizePerPage) {
      onSizePerPageChange(newSize);
    }
  };

  return (
    <div className="admin-pagination-toolbar">
      {isLoading ? (
        <div className="admin-pagination-loading">
          <span className="spinner spinner-primary"></span>
          <span>Cargando...</span>
        </div>
      ) : (
        <span className="admin-pagination-summary">
          Mostrando filas {formatInteger(fromRow)} a {formatInteger(toRow)} de{" "}
          {formatInteger(totalSize)}
        </span>
      )}
      {showPageSizeControls && (
        <div className="admin-pagination-size" aria-label="Filas por pagina">
          <span className="admin-pagination-size__label">Filas</span>
          {pageSizeOptions.map((option) => {
            const isSelected = currentSizePerPage === option.page;
            return (
              <button
                key={option.page}
                type="button"
                className={`admin-pagination-size__button ${isSelected ? "is-active" : ""}`}
                disabled={totalSize === 0 || isSelected}
                onClick={() => changePageSize(option.page)}
                aria-pressed={isSelected}
              >
                {option.text}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
